// modules
import { createAction } from 'redux-actions'

export const setPatientProfile = createAction('SET_PATIENT_PROFILE')
export const setPatientActiveProgram = createAction(
  'SET_PATIENT_ACTIVE_PROGRAM'
)
export const setPatientAllPrograms = createAction('SET_PATIENT_ALL_PROGRAMS')

export const setPatientVitalGraph = createAction('SET_PATIENT_VITAL_GRAPH')
export const setPatientAssignedMeasurement = createAction(
  'SET_PATIENT_ASSIGNED_MEASUREMENT'
)
export const setPatientMeasurementActivityLog = createAction(
  'SET_PATIENT_MEASUREMENT_ACTIVITY_LOG'
)

export const setPatientActivityLog = createAction('SET_PATIENT_ACTIVITY_LOG')

export const setPatienttGoals = createAction('SET_PATIENT_GOALS')
export const setPatientGoalInterventions = createAction(
  'SET_PATIENT_GOAL_INTERVENTIONS'
)

export const deletePatientData = createAction('DELETE_PATIENT_DATA')

export const setIsAddPatientModalVisible = createAction(
  'SET_IS_ADD_PATIENT_MODAL_VISIBLE'
)

export const setPatientDiseases = createAction('SET_PATIENT_DISEASES')
